const saveCategories = (data) => ({
    type: "SAVE_CATEGORIES",
    payload: data, 
  });
  
  export { saveCategories };
  